import Screen1 from './Screen1';
import Screen2 from './Screen2';
import Screen3 from './Screen3';
import Screen4 from './Screen4';
import Screen5 from './Screen5';

const screens = [
    Screen1, // russia
    Screen3, // philippines
    Screen2, // iceland
    Screen4, // japan
    Screen5  // algeria
];

export default screens;


// WEBPACK FOOTER //
// ./src/js/screens/index.js